import { render } from "./index.vue?vue&type=template&id=236d1850"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=236d1850&lang=sass"
script.render = render

export default script